import './purge_versions_modal.html'
import {IModalScope} from "../types/angular-types";

angular.module('GorillaBoy.DocumentViewer')
.controller('PurgeVersionsModalCtrl', PurgeVersionsModalCtrl);

interface IScope extends IModalScope {
    purgingInProgress: boolean;
    storageSpaceSavings: string;
    formData: {confirm: boolean}
}

PurgeVersionsModalCtrl.$inject = ['$scope', 'CompanionService', 'DocumentState', '$location', '$log', '$filter'];
function PurgeVersionsModalCtrl($scope : IScope, CompanionService: any, DocumentState: any, $location: ng.ILocationService,
                                $log: ng.ILogService, $filter: any) {
    $scope.purgingInProgress = false;
    $scope.storageSpaceSavings = $filter('getHumanReadableSize')( DocumentState.totalVersionsSize - DocumentState.activeVersion.Size);

    $scope.formData = {
        confirm: false
    };

    $scope.okButtonClickHandler = () => {
        $scope.purgingInProgress = true;
        CompanionService.purgeVersions(DocumentState.documentId)
            .then(function(newDocumentId) {
                $log.debug("Redirecting the user to new document URL " + newDocumentId);
                $location.url("/document/" + newDocumentId);
            })
            .finally(() => {
                $scope.purgingInProgress = false;
                $scope.$close();
            });
    };
};